import { ARENA_HALF, BASE_SPEED, MOVE_RESPONSE } from './constants';

export interface Kinematic {
  x: number;
  y: number;
  vx: number;
  vy: number;
}

/**
 * Intègre un pas de déplacement. Fonction pure partagée : le serveur l'utilise pour la simulation
 * autoritaire, le client pour la prédiction locale (avec rejeu des inputs non confirmés).
 */
export function stepMovement(k: Kinematic, mx: number, my: number, speedMul: number, radius: number, dt: number, response = 1, half = ARENA_HALF): void {
  let len = Math.hypot(mx, my);
  if (len > 1) {
    mx /= len;
    my /= len;
    len = 1;
  }
  const target = BASE_SPEED * speedMul;
  const tx = mx * target;
  const ty = my * target;
  const f = 1 - Math.exp(-MOVE_RESPONSE * response * dt);
  k.vx += (tx - k.vx) * f;
  k.vy += (ty - k.vy) * f;
  k.x += k.vx * dt;
  k.y += k.vy * dt;
  const lim = half - radius;
  if (k.x < -lim) {
    k.x = -lim;
    if (k.vx < 0) k.vx = 0;
  } else if (k.x > lim) {
    k.x = lim;
    if (k.vx > 0) k.vx = 0;
  }
  if (k.y < -lim) {
    k.y = -lim;
    if (k.vy < 0) k.vy = 0;
  } else if (k.y > lim) {
    k.y = lim;
    if (k.vy > 0) k.vy = 0;
  }
}
